import { Input, Button } from 'ant-design-vue'
import InputNumber from './input-number.vue'
/* istanbul ignore next */
InputNumber.install = function (Vue) {
  Vue.component(InputNumber.name, InputNumber)
  Vue.use(Input)
  Vue.use(Button)
}

export default InputNumber
